import { useLocalization } from "@fluent/react";
import { Checkbox, Tooltip } from "@narmi/design_system";

type DualApprovalCheckboxCellProps = {
  isOwnRequest: boolean;
  isChecked: boolean;
  onChange: () => void;
};

const DualApprovalCheckboxCell = ({
  isOwnRequest,
  isChecked,
  onChange,
}: DualApprovalCheckboxCellProps) => {
  const { l10n } = useLocalization();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {isOwnRequest ? (
        <Tooltip
          side="top"
          maxWidth="210px"
          text={l10n.getString("own-request-tooltip")}
        >
          <Checkbox disabled checked={isChecked} />
        </Tooltip>
      ) : (
        <Checkbox checked={isChecked} onChange={onChange} />
      )}
    </div>
  );
};

export default DualApprovalCheckboxCell;
